import { Header } from "../../../ui/header/header";
import './print-create-order-info.scss';
import iconReturn from '../../../../assets/img/icon/return.svg';
import iconSave from '../../../../assets/img/icon/save.svg';
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "../../../ui/button/button";
import { useErrorMessage } from "../../../../hooks/use-error-message";
import { Env } from "../../../../models/env";
import { PrintLabeledUI } from "../print-create-order/component/print-labeled-ui";
import { Input } from "../../../ui/input/input";
import { TextArea } from "../../../ui/textarea/textarea";
import { Radiobutton } from "../../../ui/input/radiobutton";
import { Select } from "../../../ui/select/select";
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { push } from "connected-react-router";
import { PathParams, RoutingPath } from '../../../../routes/routing-path';
import { useParams } from "react-router-dom";
import { dialogActions } from "../../../dialog/slice/dialog-slice";
import { orderLockActions } from "../../../../slices/lock-order-slice";
import { commonActions } from "../../../../slices/common-slice";
import { PrintSelectFormDesignation } from "./component/print-select-form-designation";
import { DeliveryAddressInfoInput } from "./component/delivery-address-info-input";
import { PrintDeliveryDataEntity } from "../../../../models/sift/json/print-model";

// const proxyShopCode = '0299999';
const proxyShopCode = '';
export const PrintCreateOrderInfo = () => {
  const { pushMessage } = useErrorMessage();
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const { 
    deliveryStore: _deliveryStore,
    deliveryTypeInitValue,
    masterShopList,
    masterShopIdList,
   } = useAppSelector((state) => ({
    deliveryStore: state.orderPreparation.orderData?.lastName || '',
    deliveryTypeInitValue: state.storage.data.deliveryType,
    masterShopList: state.common.data.masterShop?.lnwMasterShop.shop?.[0].shopData,
    masterShopIdList: state.common.masterShopIdList,
  }))
  const dispatch = useAppDispatch();
  const mijissou = useCallback(() => {
    pushMessage('確認', [`v${Env.version}では未実装です。`]);
  }, [pushMessage]);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [memo, setMemo] = useState('');
  const [isError, setIsError] = useState(false);
  
  // 配送情報
  const [deliveryType, setDeliveryType] = useState<'store' | 'private'>((deliveryTypeInitValue as 'store' | 'private') || 'store');
  const [deliveryStore, setDeliveryStore] = useState(_deliveryStore || '');
  const [deliveryStoreList, setDeliveryStoreList] = useState<{ value: string, label: string }[]>([]);
  const [deliveryInfo, setDeliveryInfo] = useState<PrintDeliveryDataEntity>({});

  // -- 発送帳票指定ボタン --
  const handlerClickFormDesignation = useCallback(() => {
    // dispatch(orderLockActions.check(
    //   kijshopCd, shopOrderId, {
    //     yes: () => {
          dispatch(dialogActions.push({
            title: '発送帳票を選択',
            element: <PrintSelectFormDesignation
              kijshopCd={kijshopCd}
              shopOrderId={shopOrderId}
              callback={setDeliveryInfo}
            />,
          }));
    //     },
    //     no: () => {
    //       dispatch(orderLockActions.setId(''));
    //       dispatch(push(RoutingPath.cnv.orders({ kijshopCd })));
    //     },
    //   },
    // ));
  }, []);
  // -- 配送情報登録 --
  const handlerClickDeliveryStoreRegister = useCallback(() => {
    dispatch(dialogActions.push({
      title: '配送先情報入力',
      element: <DeliveryAddressInfoInput
        kijshopCd={kijshopCd}
        shopOrderId={shopOrderId}
        deliveryInfo={deliveryInfo}
        callback={setDeliveryInfo}
      />,
    }));
  }, [kijshopCd, shopOrderId, deliveryInfo]);

  useEffect(() => {
    if (deliveryType === 'store') {
      // 代理発注の時
      if (proxyShopCode) {
        setDeliveryStoreList([{ value: proxyShopCode, label: proxyShopCode }]);
        setDeliveryStore(proxyShopCode);
      } else {
        if (masterShopList) {
          const shopList: { value: string, label: string }[] = masterShopList.map((v) => ({
            value: v.$.shopCode!,
            label: v.name?.[0].$.lastName!,
          })) || [];
          setDeliveryStoreList(shopList);
          const deliStore = (masterShopIdList.find((v) => v === _deliveryStore)) ? _deliveryStore
                  : (masterShopIdList.find((v) => v === kijshopCd)) ? kijshopCd : masterShopIdList[0];
          setDeliveryStore(deliStore);
        }
      }
      // set
    }
  }, [masterShopList, masterShopIdList]);

  useEffect(() => {
    dispatch(commonActions.getData(kijshopCd));
  }, []);

  const handleClickSave = useCallback(() => {
    if (!name) {
      setIsError(true);
      pushMessage(
        '確認',
        ['お客様氏名は必須項目です。'],
      );
      return;
    }
    dispatch(push(RoutingPath.cnv.printOrderAddImageUpload({ kijshopCd, shopOrderId })))
  }, [
    dispatch,
    pushMessage,
    name,
    kijshopCd,
    shopOrderId,
  ]);

  const handlerClickFinish = useCallback(() => {
    dispatch(dialogActions.pushMessage({
      title: '確認',
      message: ['保存していない内容は失われます。終了してもよろしいですか？'],
      buttons: [
        {
          label: 'いいえ',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        },
        {
          label: 'はい',
          callback: () => {
            dispatch(dialogActions.pop());
            dispatch(push(RoutingPath.cnv.print({ kijshopCd })));
          },
        },
      ],
    }));
  }, []);
  
  return (
    <div className="column_direction_wrap">
      <Header />
      <div className="print_create_order_info">
        <div className="print_create_order_info__menu">
          <div>
            <Button
              label="保存しないで終了"
              icon={<img
                src={iconReturn}
                alt=""
              />}
              onClick={handlerClickFinish}
              color="light"
            />
            <Button
              label="保存して次へ"
              color="warning"
              icon={<img
                src={iconSave}
                alt=""
              />}
              onClick={handleClickSave}
            />
          </div>
        </div>
      </div>
      <div className="print_create_order_info__category">
        <div className="bottom_border_header search_print_order__header">
          お客様情報入力
        </div>
        <PrintLabeledUI width={250} label="お客様氏名">
          <Input
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setIsError(false);
            }}
            error={isError}
          />
        </PrintLabeledUI>
        <PrintLabeledUI width={250} label="連絡先">
          <Input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </PrintLabeledUI>
        <PrintLabeledUI width={250} label="お客様メモ(DP袋番号など)">
          <TextArea
            style={{ width: '320px', height: '150px' }}
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
          />
        </PrintLabeledUI>
        <PrintLabeledUI width={250} label="配送先指定">
          <div className="item_body">
            <div className="radio_buttons_box">
              <Radiobutton
                value="store"
                label="店舗配送"
                checkState={deliveryType}
                onClick={() => {
                  if (deliveryType === 'private') {
                    setDeliveryInfo({});
                  }
                  setDeliveryType('store');
                }}
              />
              <Radiobutton
                value="private"
                label="個別配送"
                checkState={deliveryType}
                onClick={() => {
                  if (deliveryType === 'store') {
                    setDeliveryInfo({});
                  }
                  setDeliveryType('private');
                }}
              />
            </div>
            {deliveryType === 'store' ? (
                <div className="item_body__type_store">
                  <Select list={deliveryStoreList} value={deliveryStore} />
                      <Button
                        label="発送帳票指定"
                        onClick={handlerClickFormDesignation}
                      />
                </div>
              ) : (<></>)}
              {deliveryType === 'private' ? (
                <Button
                  label="配送情報登録"
                  onClick={handlerClickDeliveryStoreRegister}
                />
              ) : (<></>)}

          </div>
        </PrintLabeledUI>
      </div>
    </div>
  )
}